import React, { useEffect, useState } from "react";
import { SubModule } from "../types/SubModule";
import { Form, Button, Row, Col } from "react-bootstrap";
import { useSelector } from "react-redux";
import { StoreState } from "../redux/reducers";
import "../styles/Form.css";

interface Props {
  onSave: (sub: SubModule) => void;
  initialData?: SubModule | null;
  clearAfterSubmit: () => void;
}

const initialState: SubModule = {
  id: 0,
  moduleId: 0,
  name: "",
};

const SubModuleForm: React.FC<Props> = ({
  onSave,
  initialData,
  clearAfterSubmit,
}) => {
  const [form, setForm] = useState<SubModule>(initialState);
  const modules = useSelector((state: StoreState) => state.module);

  useEffect(() => {
    if (initialData) {
      setForm({
        ...initialData,
        moduleId: Number(initialData.moduleId),
      });
    }
  }, [initialData]);

  const handleChange = (e: React.ChangeEvent<any>) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: name === "moduleId" ? parseInt(value) : value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(form);
    setForm(initialState);
    clearAfterSubmit();
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Row className="mb-1">
        <Col className="form-column">
          <Form.Group controlId="moduleId">
            <Form.Label>module</Form.Label>
            <Form.Select
              name="moduleId"
              value={form.moduleId ? form.moduleId.toString() : ""}
              onChange={handleChange}
              required
              style={{
                borderColor: "rgb(215, 210, 210)",
              }}
            >
              <option value="">Select a Module</option>
              {modules.map((module) => (
                <option key={module.id} value={module.id}>
                  {module.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col className="form-column">
          <Form.Group controlId="name">
            <Form.Label>Sub Module Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={form.name}
              onChange={handleChange}
              required
            />
          </Form.Group>
        </Col>
      </Row>
      <Row className="mb-1">
        <Col md={12}>
          <div className="form-buttons">
            <Button type="submit" className="btn-save">
              {initialData ? "Update" : "Add"} Sub Module
            </Button>
          </div>
        </Col>
      </Row>
    </Form>
  );
};

export default SubModuleForm;
